function dedupeCalls(func) {
	let pendingPromise;
	return function (...args) {
		if (!pendingPromise) {
			pendingPromise = new Promise((resolve, reject) => {
				func.apply(this, args)
					.then(resolve)
					.catch(reject)
					.finally(() => {
						pendingPromise = null;
					})
			});
		}
		return pendingPromise;
	};
}

document.addEventListener("DOMContentLoaded", async () => {
	const params = new URL(document.location).searchParams;
	if (params.get("minicart")) {
		Alpine.store("cart").minicart.activate();
		document.querySelector(".close-minicart").addEventListener("click", () => {
			window.location.href = `https://app.${window.location.hostname}`;
		});
	}

	const getTemplates = async () => {
		const sections = ["minicart", "cart-main"];
		const minicartTemplate = await fetch(`/?sections=${sections[0]}`)
			.then((res) => res.json())
			.then((res) => res);
		const cartTemplate = await fetch(`/?sections=${sections[1]}`)
			.then((res) => res.json())
			.then((res) => res);
		const sectionsList = [minicartTemplate, cartTemplate];
		return Object.assign({}, ...sectionsList);
	};
	const handleCartAddEvent = dedupeCalls(async () => {
		const cartData = await fetch("/cart.js", {
			method: "GET",
			credentials: "same-origin",
		})
			.then((res) => res.json())
			.then((res) => res.items);

		const templates = await getTemplates();
		const cart = {
			items: cartData,
			sections: templates,
		};

		window.dispatchEvent(
			new CustomEvent("cart:refresh", {
				detail: {
					cart,
				},
			}),
		);
	});

	["rebuy:cart.add", "cart:add"].forEach((event) => {
		document.addEventListener(event, handleCartAddEvent);
		window.addEventListener(event, handleCartAddEvent);
	});

	const cartCount = document.querySelector(".cart-count");
	document.addEventListener("rebuy:cart.change", async () => {
		const cartData = await fetch("/cart.js", {
			method: "GET",
			credentials: "same-origin",
		})
			.then((res) => res.json())
			.then((res) => res);

		if (cartData.item_count !== 0) {
			cartCount.classList.remove("hidden");
			cartCount.innerText = cartData.item_count;
		} else {
			cartCount.classList.add("hidden");
		}
	});

	const minicartForm = document.querySelector(".minicart-form");
	minicartForm.addEventListener("keypress", (e) => {
		const key = e.charCode || e.keyCode || 0;
		if (key === 13) {
			e.preventDefault();
		}
	});
});
